import {
  BookOpen,
  CalendarCheck,
  ClipboardList,
  FileText,
  GraduationCap,
  LayoutDashboard,
  Mail,
  Network,
  Settings,
  SlidersHorizontal,
  Tag,
  Users,
} from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'
import { useTenantPath } from '@/lib/tenant'
import { cn } from '@/lib/utils'

const teacherNavItems = [
  {
    title: 'ダッシュボード',
    href: '/teacher',
    icon: LayoutDashboard,
  },
  {
    title: 'コース管理',
    href: '/teacher/courses',
    icon: BookOpen,
  },
  {
    title: 'レッスン管理',
    href: '/teacher/lessons',
    icon: GraduationCap,
  },
  {
    title: 'タグ管理',
    href: '/teacher/tags',
    icon: Tag,
  },
  {
    title: '受講者管理',
    href: '/teacher/students',
    icon: Users,
  },
  {
    title: '研修管理',
    href: '/teacher/trainings',
    icon: CalendarCheck,
  },
  {
    title: '研修アンケート',
    href: '/teacher/training-surveys',
    icon: ClipboardList,
  },
  {
    title: '組織マスター',
    href: '/teacher/organization',
    icon: Network,
  },
  {
    title: '通知テンプレート',
    href: '/teacher/notification-templates',
    icon: Mail,
  },
  {
    title: '研修設定',
    href: '/teacher/training-config',
    icon: SlidersHorizontal,
  },
  {
    title: '設定',
    href: '/teacher/settings',
    icon: Settings,
  },
  {
    title: 'マニュアル',
    href: '/teacher/manual',
    icon: FileText,
  },
]

export default function TeacherNav() {
  const location = useLocation()
  const tp = useTenantPath()

  return (
    <nav className="hidden w-64 shrink-0 border-r bg-card lg:block">
      <div className="p-6">
        <h2 className="text-lg font-bold text-foreground">講師メニュー</h2>
      </div>
      <ul className="space-y-1 px-3 pb-4">
        {teacherNavItems.map((item) => {
          const fullPath = tp(item.href)
          const isActive =
            item.href === '/teacher'
              ? location.pathname === fullPath
              : location.pathname.startsWith(fullPath)
          const Icon = item.icon

          return (
            <li key={item.href}>
              <Link
                to={fullPath}
                className={cn(
                  'flex items-center gap-3 rounded-lg px-4 py-3 text-sm transition-colors',
                  'hover:bg-emerald-50 hover:text-emerald-700',
                  isActive && 'bg-emerald-100 font-medium text-emerald-700',
                )}
              >
                <Icon className="h-5 w-5" />
                <span>{item.title}</span>
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
